export const colors = {
  uguWhite: '#FFFFFF',
  uguPurple: '#1A1E3D',
  uguBrightPurple: '#7181FF',
  uguBrightPurpleLight: '#E1E5FF',
  uguBrightPurpleDark: '#495DF4',
  uguBrightBlue: '#495DF4',
  uguLightPurple: '#3C405A',
  uguLighterGrey: '#EFF0F2',
  uguLightLightGrey: '#f6f6f6',
  uguLightGrey: '#D8D8D8',
  uguGrey: '#a0a0a0',
  uguDarkGrey: '#979797',
  // uguRed: '#C7424F', //old
  uguRed: '#DE5664', //new
  uguGreen: '#4DAD9B',
  // uguYellow: '#E9B735', //old
  uguYellow: '#F1C85D', //new
  // uguBlue: '#6BB5C9', //old
  uguBlue: '#75BFD3', //new
  uguLightBlue: '#d9e8ec',
  uguLightLightBlue: '#E1F0F4',
  uguLightYellow: '#f3e9d0',
  uguLightBlack: '#313145',
  uguLightRed: '#F4D9DC',
  uguGray: '#EAEAEA',
  uguLightGray: '#F1F1F1',
  uguLightGreen: '#4EAF9D',
  uguIvory: '#f0f2ff',
  borderGray: '#c6c7ce',
  // Referral Dashboard
  fillColor: '#FCFCFC',
  borderColor: '#DDDEE6',
  uguLightBrightPurple: '#F0F2FF',
  uguLightBrightPurpleLanding: '#E7EAFF',
}

export const fontFamilies = {
  light: 'var(--font-figtree); font-weight: 300',
  regular: 'var(--font-figtree); font-weight: 400',
  medium: 'var(--font-figtree); font-weight: 500',
  semiBold: 'var(--font-figtree); font-weight: 600',
  bold: 'var(--font-figtree); font-weight: 700',
  extraBold: 'var(--font-figtree); font-weight: 800',
  sofiaPro: 'var(--font-sofia-pro)',
  openSans: 'var(--font-open-sans)',
  OpenSansRegular: 'var(--font-open-sans)',
  inter: 'var(--font-inter)',
  outfit: 'var(--font-inter)',
}

export const defaultTheme = {
  colors: {
    background: colors.uguWhite,
    siteFooter: colors.uguPurple,
    modalBackground: 'rgba(26, 30, 61, 0.71)',
    formFieldBorder: 'rgba(216, 216, 216, 0.25)',
    errorMessage: colors.uguRed,
    ctaButton: colors.uguYellow,
    lightText: 'rgba(0, 0, 0, 0.38)',
    checkboxBg: '#EAEAEA',
    darkGreyText: colors.uguDarkGrey,
    headerIcons: colors.uguPurple,
  },
}

export const BorderRadius = {
  medium: '1rem',
  large: '1.875rem',
  round: '50%',
}

export const FormFieldHeight = {
  large: '2.5rem',
}

//z-index
const zIndexList = [
  //higher
  'dialog-background',
  //lower
] as const

export type ZIndexName = (typeof zIndexList)[number] | 'negative'

export const zIndex = (name: ZIndexName) => {
  if (name === 'negative') return -1

  const targetIndex = zIndexList.length
  return zIndexList.length - targetIndex
}
